import {ButtonPrimary, ButtonSecondary, Checkbox, ModalBase} from "pac-ux-components";
import React, {useEffect} from "react";
import {useCookies} from "react-cookie";

function StoreSelectionModal(props) {
    const [saving, setSaving] = React.useState(true);
    const [loading, setLoading] = React.useState(true);
    const [error, setError] = React.useState(false);
    const apiRoot = process.env.REACT_APP_API_ROOT_URL;
    const [cookies] = useCookies(['idToken']);
    const apiHeaders = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + cookies.idToken
    }

    const [allStores, setAllStores] = React.useState([]);
    const [productStores, setProductStores] = React.useState([]);
    const [originalProductStores, setOriginalProductStores] = React.useState([]);


    async function getStores() {
        const response = await fetch(apiRoot + '/backoffice/tenants?page=0&size=100', {headers: apiHeaders});
        const data = await response.json();
        let storeArray = [];
        for (const tenant of data.content) {
            const storeResponse = await fetch(apiRoot + '/backoffice/tenants/' + tenant.id + '/stores?page=0&size=100', {headers: apiHeaders});
            const storeData = await storeResponse.json();
            for (const store of storeData.content) {
                storeArray.push(store);
            }
        }
        setAllStores(storeArray);
    }

    async function getStoresForPacProduct() {
        const response = await fetch(apiRoot + '/backoffice/pac-products/' + props.productId + '/stores?page=0&size=100', {headers: apiHeaders});
        const data = await response.json();
        let storeArray = {};
        for (const productStore of data.content) {
            storeArray[productStore.id] = productStore.name;
        }
        const storeArrayCopy = JSON.parse(JSON.stringify(storeArray));
        setOriginalProductStores(storeArrayCopy);
        setProductStores(storeArray);

    }

    async function save() {
        try {
            for (const eachStore of allStores) {
                if (productStores[eachStore.id] && !originalProductStores[eachStore.id]) {

                    //assign the payment method to the psp
                    const response = await fetch(apiRoot + '/backoffice/pac-products/' + props.productId + '/stores/' + eachStore.id + '/assign', {
                        method: 'POST', headers: apiHeaders,
                    });
                    if (!response.ok) {
                        throw new Error('Failed to assign store');
                    }
                }
                if (originalProductStores[eachStore.id] && !productStores[eachStore.id]) {
                    //unassign the payment method from the psp
                    const response = await fetch(apiRoot + '/backoffice/pac-products/' + props.productId + '/stores/' + eachStore.id + '/unassign', {
                        method: 'POST', headers: apiHeaders,
                    });
                    if (!response.ok) {
                        throw new Error('Failed to unassign store');
                    }
                }
            }

        } catch (error) {
            setError(error);
            setSaving(false);
        }
    }

    useEffect(() => {
        // Define an async function inside useEffect
        const fetchData = async () => {
            await getStores();
            await getStoresForPacProduct();
            setSaving(false);
            setLoading(false);// Only set loading to false after the data is fetched
        };
        fetchData();
    }, []);

    return (<div>
        <ModalBase
            style={{display: (props.display === true) ? 'block' : 'none'}}
        >
            <form
                onSubmit={async (e) => {
                    e.preventDefault();
                    setSaving(true);

                    e.stopPropagation();
                    return;
                }}
            >
                <div style={{width: '619px', maxHeight: '500px', overflow: 'auto', paddingLeft: 33, fontFamily: 'Inter'}}>
                    <div style={{
                        width: '100%',
                        color: 'black',
                        fontSize: 24,
                        fontWeight: '700',
                        marginTop: 38,
                        paddingBottom: 22,
                        wordWrap: 'break-word'
                    }}>Stores
                    </div>
                    {loading ?
                        <div style={{textAlign: 'center', padding: 16}}>Loading...</div>
                        : null}
                    <table width="400px" className="Table" style={{}}>
                        <tbody>
                        {allStores.map((item) => (
                            <tr key={item.id} style={{
                            height: 48,
                            fontSize: 16}}>
                                <td>
                                <Checkbox
                                    marked={productStores[item.id] ? "selected" : "unselected"}
                                    onChange={(e) => {
                                        if (e.target.checked) {
                                            productStores[item.id] = item.name;
                                        } else {
                                            delete productStores[item.id];
                                        }
                                        setProductStores({...productStores});
                                    }}
                                    id={item.id}

                                />

                                </td>
                                <td style={{marginLeft: 8}}><label htmlFor={item.id}>{item.name}</label></td>

                            </tr>
                        ))}
                        </tbody>

                    </table>
                </div>

                <div style={{
                    float: 'right', marginBottom: 32, marginRight: 32,
                }}>

                    <ButtonSecondary
                        onClick={() => {
                            props.closeModal(false)
                        }}
                        style={{
                            marginRight: 32,
                        }}>Cancel</ButtonSecondary>

                    <ButtonPrimary
                        type='submit'
                        disabled={saving}
                        onClick={async () => {
                            setSaving(true);
                            await save();
                            props.closeModal(true);
                        }}
                    >Save</ButtonPrimary>
                </div>
            </form>
        </ModalBase>
    </div>);
}

export default StoreSelectionModal;